import React from 'react';
import { TileType } from '../enum';
import { TileViewProps } from '../types';
import HorizontalCardTile from './views/horizontalCardTile';
import ImageTile from './views/imageTile';
import TextTile from './views/textTile';
import VerticalCardTile from './views/verticalCardTile';

export function TileView({
  data,
  onClick,
  index,
  isLoading,
  viewType,
}: TileViewProps) {
  // Function that renders the appropriate tile based on viewType
  const renderTile = () => {
    switch (viewType) {
      case TileType.IMAGE_VIEW:
        return (
          <ImageTile
            data={data}
            onClick={onClick}
            index={index}
            isLoading={isLoading}
          />
        );
      case TileType.TEXT_VIEW:
        return (
          <TextTile
            data={data}
            onClick={onClick}
            index={index}
            isLoading={isLoading}
          />
        );
      case TileType.HORIZONTAL_CARD:
        return (
          <HorizontalCardTile
            data={data}
            onClick={onClick}
            index={index}
            isLoading={isLoading}
          />
        );
      case TileType.VERTICAL_CARD:
      default:
        return (
          <VerticalCardTile
            data={data}
            onClick={onClick}
            index={index}
            isLoading={isLoading}
          />
        );
    }
  };

  return renderTile();
}

export default TileView;
